"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getParams = function getParams(settings) {
  var bodyParams = {
    // eslint-disable-next-line comma-dangle
    MailTemplatePath: settings.defaultTemplateSettings.MailTemplatePath,
    // Path to the Mail template -> must be from root of Mailtemplates => not be needed for download
    EmailReceiver: settings.defaultTemplateSettings.EmailReceiver,
    // Email receiver, please use your own => not be needed for download
    HtmlTemplatePath: settings.defaultTemplateSettings.htmlTemplatePath,
    // Path to html for PDF creation
    PdfName: settings.defaultTemplateSettings.pdfName,
    // name of pdf file
    LanguageCode: settings.defaultTemplateSettings.languageCode,
    // Setting language so html and email template must be available in this language
    EmailContent: // use for email template, to substitute values in the email  => not be needed for download, token in emails must be in {}, so this is {body}
    {
      body: settings.defaultTemplateSettings.emailBodyContent,
      emailSender: settings.defaultTemplateSettings.emailSender,
      hcpEmail: settings.defaultTemplateSettings.hcpEmail,
      name: settings.defaultTemplateSettings.name,
      emailTitle: settings.defaultTemplateSettings.emailTitle
    },
    PdfContent: {
      logo: settings.defaultTemplateSettings.logoElement,
      header: settings.defaultTemplateSettings.header,
      body: settings.defaultTemplateSettings.pdfContent,
      footer: settings.defaultTemplateSettings.footer,
      customStyle: settings.defaultTemplateSettings.customStyle
    }
  }; //addtinial params from FE 

  if (settings.defaultTemplateSettings.additionalParams) {
    Object.keys(settings.defaultTemplateSettings.additionalParams).map(function (setting) {
      bodyParams[setting] = settings.defaultTemplateSettings.additionalParams[setting];
    });
  }

  return bodyParams;
};

var _default = getParams;
exports["default"] = _default;